import { List } from "immutable"
import { donationVariant, frequency, pushDatalayer, scheduledDatalayerObject } from "./datalayer"

const schedulePurchaseDataLayer = (amount: string, transactionId: string, frequency: frequency, variant: donationVariant) => (
  schedulePushDatalayer({
    event: 'purchase',
    currency: 'EUR',
    transaction_id: transactionId,
    value: amount,
    donationFrequency: frequency,
    items: [{
      item_name: 'donation',
      item_category: frequency,
      item_variant: variant,
      price: amount,
      quantity: 1
    }]
  })
)

const beginCheckoutDataLayer = (amount: string, frequency: frequency, variant?: donationVariant) => (
  pushDatalayer({
    event: 'begin_checkout',
    currency: 'EUR',
    value: amount,
    donationFrequency: frequency,
    items: [{
      item_name: 'donation',
      item_category: frequency,
      item_variant: variant || "",
      price: amount,
      quantity: 1
    }]
  })
)

const schedulePushDatalayer = (data: scheduledDatalayerObject) => {
  let gtmPush = window.localStorage.getItem("gtmPush")
  let gtmPushJson: Array<{}> = JSON.parse(gtmPush || "[]")
  const gtmPushList = List(gtmPushJson)
  const newList = gtmPushList.push(data)

  window.localStorage.setItem("gtmPush", JSON.stringify(newList.toArray()))
}

const sendPendingGtmEvents = () => {
  const url = new URL(document.location.toString())
  const paymentSuccess = url.searchParams.get("paymentSuccess") == "true"
  if (!paymentSuccess) return window.localStorage.removeItem("gtmPush")

  let gtmPush = window.localStorage.getItem("gtmPush")
  let gtmPushJson: Array<{}> = JSON.parse(gtmPush || "[]")

  gtmPushJson.forEach(gtm => {
    pushDatalayer(gtm)
  })
  window.localStorage.removeItem("gtmPush")
}

const propositionDonationFormStartPushDatalayer = () => {
  pushDatalayer({
    event: "donation_blocks",
    flow: "stap 2 - form start",
  })
}

const propositionDonationFormDonatePushDatalayer = (optin: boolean) => {
  pushDatalayer({
    event: "donation_blocks",
    flow: "stap 2 - button doneer nu",
    "email_opt-in": optin ? "ja" : "no"
  })
}

export const donationDataLayerServices = {
  schedulePurchaseDataLayer,
  beginCheckoutDataLayer,
  sendPendingGtmEvents,
  propositionDonationFormStartPushDatalayer,
  propositionDonationFormDonatePushDatalayer,
}
